<template>
  <div>
    <div style="display:block;z-index: 10;position: fixed;right: 1px;bottom: 5%;width: 50px;opacity: 0.8;margin-right: 25px;">

      <el-button
        class="home_btn"
        icon="el-icon-phone-outline"
        @click="clickPhone"
        circle
      ></el-button>

      <el-button
        class="home_btn"
        icon="el-icon-download"
        @click="clickDownload"
        circle
      ></el-button>

      <a href="#">
        <el-button
          class="home_btn"
          icon="el-icon-top"
          circle
        ></el-button>
      </a>

    </div>

    <connect ref="connect"></connect>
    <download ref="download"></download>

  </div>

</template>
<script>
import connect from "./connect";
import download from "./download";
export default {
  name: "Fixed",
  components: {
    connect,
    download,
  },
  data() {
    return {
      dialogPhone: false,
      centerDialogVisible: false,
    };
  },
  methods: {
    clickPhone() {
      this.$refs.connect.showdialogPhone();
    },
    clickDownload() {
      this.$refs.download.click();
    },
  },
};
</script>
<style lang="stylus" scoped>
.home_btn {
  margin: 5px 0;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/fixed/index.vue